import {useSelector} from 'react-redux';

function useGetFilter() {
  return useSelector((state: any) => state.assistants.filter_assistant);
}

export default useGetFilter;
